export const siteDescription = 'Ongehoord is onderzoeksorganisatie. Wij onderzoeken en publiceren over de Nederlandse dierindustrie.'
export const siteName = 'Ongehoord'
